@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row.Type && $.row.Type.toLowerCase() === 'appointment') {
    <div class="flex align-items-center">

      @if ($.row.is_late_cancel && $.row.is_late_cancel === true ) {
        <p-tag
          class="text-xxs text-white uppercase font-normal"
          severity="danger"
          >{{ 'CLIENT_BOOKING.V2.LATE_CANCEL' | translate }}</p-tag
        >
      }
      @else {   
      @if ($.row.Status && $.row.Status.toLowerCase() === 'scheduled') {
        <p-tag
          class="text-xxs bg-cyan-500 text-white uppercase font-normal"
          severity="info"
          >{{ $.row.Status }}</p-tag
        >
      }
      @if ($.row.Status && $.row.Status.toLowerCase() === 'booked') {
        <p-tag
          class="text-xxs bg-cyan-500 text-white uppercase font-normal"
          severity="info"
          >{{ $.row.Status }}</p-tag
        >
      }
      @if ($.row.Status && $.row.Status.toLowerCase() === 'attended') {
        <p-tag
          class="text-xxs text-white uppercase font-normal"
          severity="success"
          >{{ $.row.Status }}</p-tag
        >
      }
      @if ($.row.Status && $.row.Status.toLowerCase() === 'noshow') {
        <p-tag
          class="text-xxs text-white uppercase font-normal"
          severity="danger"
          >{{ $.row.Status }}</p-tag
        >
      }
      @if ($.row.Status && $.row.Status.toLowerCase() === 'comp') {
        <p-tag
          class="text-xxs surface-600 text-white uppercase font-normal"
          severity="info"
          >{{ $.row.Status }}</p-tag
        >
      }
      @if ($.row.Status && $.row.Status.toLowerCase() === 'completed') {
        <p-tag
          class="text-xxs surface-600 text-white uppercase font-normal"
          severity="info"
          >{{ $.row.Status }}</p-tag
        >
      }
      @if ($.row.Status && $.row.Status.toLowerCase() === 'cancelled') {
        <p-tag
          class="text-xxs surface-600 text-white uppercase font-normal"
          severity="info"
          >{{ $.row.Status }}</p-tag
        >
      }
    }
    </div>
  }
  @if ($.row.Type && $.row.Type.toLowerCase() === 'class') {
    <div class="flex align-items-center">

      @if ($.row.is_late_cancel && $.row.is_late_cancel === true ) {
        <p-tag
          class="text-xxs text-white uppercase font-normal"
          severity="danger"
          >{{ 'CLIENT_BOOKING.V2.LATE_CANCEL' | translate }}</p-tag
        >
      }
      @else {
        @if ($.row.BookingStatus.toLowerCase() === 'booked') {
          <p-tag
            class="text-xxs bg-cyan-500 text-white uppercase font-normal"
            severity="info"
            >{{ $.row.BookingStatus }}</p-tag
          >
        }
        @if ($.row.BookingStatus.toLowerCase() === 'attended') {
          <p-tag
            class="text-xxs text-white uppercase font-normal"
            severity="success"
            >{{ $.row.BookingStatus }}</p-tag
          >
        }
        @if ($.row.BookingStatus.toLowerCase() === 'noshow') {
          <p-tag
            class="text-xxs text-white uppercase font-normal"
            severity="danger"
            >{{ $.row.BookingStatus }}</p-tag
          >
        }
        @if ($.row.BookingStatus.toLowerCase() === 'comp') {
          <p-tag
            class="text-xxs surface-600 text-white uppercase font-normal"
            severity="info"
            >{{ $.row.BookingStatus }}</p-tag
          >
        }
        @if ($.row.BookingStatus.toLowerCase() === 'completed') {
          <p-tag
            class="text-xxs surface-600 text-white uppercase font-normal"
            severity="info"
            >{{ $.row.BookingStatus }}</p-tag
          >
        }
        @if ($.row.BookingStatus.toLowerCase() === 'cancelled') {
          <p-tag
            class="text-xxs surface-600 text-white uppercase font-normal"
            severity="info"
            >{{ $.row.BookingStatus }}</p-tag
          >
        }
      }
    </div>
  }
}
